module.exports = __webpack_public_path__ + "img/288d20f0826acf5f0c0199b2b90706b4.png";